import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Quote } from 'lucide-react';
import { Reveal, Eyebrow, H2 } from './ui';
import { STORIES } from './stories';

export const SampleNote = ({ dark }) => (
  <p className={`mt-3 inline-flex rounded-full px-3 py-1 text-[11px] font-semibold ${dark ? 'bg-[#1e293b] text-[#94a3b8]' : 'bg-[#f1efe9] text-[#64748b]'}`} data-testid="stories-sample-note">
    Sample stories for illustration. Real founding-workshop stories coming soon.
  </p>
);

export const WorkshopLogo = ({ s, size = 'md' }) => (
  <span className={`inline-flex items-center gap-2 ${size === 'lg' ? 'text-lg' : 'text-sm'}`} data-testid={`story-logo-${s.slug}`}>
    <span className={`flex items-center justify-center rounded-xl text-white ${size === 'lg' ? 'h-12 w-12 text-base' : 'h-9 w-9 text-xs'} font-bold ${s.logo.font}`} style={{ background: s.logo.color }}>{s.logo.mark}</span>
    <span className="dl-display font-semibold text-[#0f172a]">{s.workshop}</span>
  </span>
);

export const LogoWall = () => (
  <div className="flex flex-wrap items-center gap-x-10 gap-y-4" data-testid="stories-logo-wall">
    {STORIES.map((s) => <WorkshopLogo key={s.slug} s={s} />)}
  </div>
);

const QuoteCard = ({ s, i }) => (
  <Reveal delay={i * 90} className="flex flex-col rounded-3xl border border-[#e7e5df] bg-[#ffffff] p-6 transition-transform duration-300 hover:-translate-y-1" data-testid={`story-quote-${s.slug}`}>
    <Quote size={22} className="text-[#0f766e]" />
    <p className="mt-4 flex-1 text-[15px] leading-relaxed text-[#334155]">“{s.quote}”</p>
    <div className="mt-6 border-t border-[#e7e5df] pt-4">
      <p className="font-semibold text-[#0f172a]">{s.owner}</p>
      <p className="text-sm text-[#64748b]">{s.role}, {s.workshop} · {s.city}</p>
    </div>
    <p className="mt-4 dl-display text-2xl font-semibold text-[#0f766e]">{s.metrics[0][0]} <span className="text-sm font-medium text-[#475569]">{s.metrics[0][1]}</span></p>
  </Reveal>
);

export const StoriesSection = () => (
  <section className="py-20 sm:py-28" data-testid="home-stories">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <Eyebrow>Workshop stories</Eyebrow>
          <H2 className="max-w-2xl">What changes when the workshop runs on Driveline.</H2>
          <SampleNote />
        </div>
        <Link to="/driveline/stories" className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#0f766e] hover:text-[#0f172a]" data-testid="home-stories-all">
          Read the full stories <ArrowRight size={15} />
        </Link>
      </div>
      <div className="mt-10"><LogoWall /></div>
      <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {STORIES.map((s, i) => <QuoteCard key={s.slug} s={s} i={i} />)}
      </div>
    </div>
  </section>
);
